$(function () {
  if (!customElements.get('global-modal')) {
    // 创建弹窗根容器
    const createModalRoot = () => {
      const existingRoot = document.getElementById('global-modal__root');
      if (existingRoot) return existingRoot;

      const root = document.createElement('div');
      root.id = 'global-modal__root';
      root.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 500;
      `;
      document.body.appendChild(root);
      return root;
    };

    customElements.define(
      'global-modal',
      class GlobalModal extends HTMLElement {
        // 基础索引
        static baseZIndex = 501;
        // 实例集合
        static instances = new Set();
        // 弹窗根容器
        static root = null;

        // 获取或创建根容器
        static getRoot() {
          if (!this.root) {
            this.root = createModalRoot();
          }
          return this.root;
        }

        constructor() {
          super();
          this.modalId = this.dataset.modalId;

          this.containerEle = this.querySelector('.global-modal__container');
          this.wrapperEle = this.querySelector('.global-modal__wrapper');
          this.closeBtnEle = this.querySelector('.global-modal__close_btn');
          this.isRendered = false;

          this.isOpen = false;
          this.level = 0;
          this.isMoving = false;

          GlobalModal.instances.add(this);
        }

        connectedCallback() {
          if (this.parentElement?.id === 'global-modal__root') return;
          this.templateContent = document.getElementById(`modal-template-${this.modalId}`);

          this.isMoving = true;
          // 创建占位符
          this.placeholder = document.createElement('div');
          this.placeholder.dataset.modalPlaceholder = this.modalId;

          // 保存原始位置并移动到根容器
          this.parentElement.insertBefore(this.placeholder, this);
          GlobalModal.getRoot().appendChild(this);

          this.isMoving = false;

          this.init();
        }

        init() {
          if (this.wrapperEle) {
            this.wrapperEle.addEventListener('click', this.handleWrapperClick.bind(this));
          }
          if (this.closeBtnEle) {
            this.closeBtnEle.addEventListener('click', this.handleCloseBtnClick.bind(this));
          }
        }

        handleWrapperClick(event) {
          if (event.target == this.wrapperEle) {
            const currentLevel = this.level;
            Array.from(GlobalModal.instances)
              .filter((modal) => modal.level >= currentLevel && modal.isOpen)
              .forEach((modal) => modal.close());
          }
        }

        handleCloseBtnClick() {
          this.close();
        }

        // 打开弹窗
        open() {
          if (!this.containerEle || this.isOpen) return;

          // 在弹窗打开前按需渲染内容
          if (!this.isRendered && this.templateContent) {
            const contentContainer = this.wrapperEle || this.containerEle;
            // 将模板内容添加到弹窗中
            if (contentContainer && this.templateContent.content) {
              // 使用深度克隆以确保所有子元素和属性都被复制
              const clone = document.importNode(this.templateContent.content, true);
              contentContainer.appendChild(clone);

              // 重新获取可能通过模板添加的关闭按钮
              if (!this.closeBtnEle) {
                this.closeBtnEle = this.querySelector('.global-modal__close_btn');
                if (this.closeBtnEle) {
                  this.closeBtnEle.addEventListener('click', this.handleCloseBtnClick.bind(this));
                }
              }
              this.isRendered = true;
            }
          }

          // 获取当前打开的所有弹窗
          const openModals = Array.from(GlobalModal.instances).filter((modal) => modal.isOpen);
          this.level = openModals.length;

          this.containerEle.style.zIndex = GlobalModal.baseZIndex + this.level * 2 + 1;
          this.dataset.isOpen = 'true';
          window.litime.disableScroll();

          requestAnimationFrame(() => {
            this.containerEle.style.visibility = 'visible';
            this.containerEle.style.opacity = 1;

            // 重排line-clamp元素，兼容ipad端省略不生效
            const lineClamps = this.containerEle.querySelectorAll('[class*="line-clamp-"]');
            lineClamps.forEach((el) => {
              el.style.display = 'none';
              el.offsetHeight;
              el.style.display = '';
            });

            this.isOpen = true;
            this.dispatchEvent(
              new CustomEvent('modal-opened', {
                detail: {
                  modalId: this.modalId,
                  level: this.level,
                  wrapperEle: this.wrapperEle,
                },
              })
            );
          });
        }

        // 关闭弹窗
        close() {
          if (!this.containerEle || !this.isOpen) return;

          Array.from(GlobalModal.instances)
            .filter((modal) => modal.level > this.level && modal.isOpen)
            .forEach((modal) => modal.close());
          delete this.dataset.isOpen;

          // 检查是否还有其他打开弹窗
          const hasOpenModals = Array.from(GlobalModal.instances).some((modal) => modal !== this && modal.isOpen);
          if (!hasOpenModals) {
            window.litime.enableScroll();
          }

          this.containerEle.style.visibility = 'hidden';
          this.containerEle.style.opacity = 0;

          this.isOpen = false;

          // 触发关闭事件
          this.dispatchEvent(
            new CustomEvent('modal-closed', {
              detail: {
                modalId: this.modalId,
                level: this.level,
                wrapperEle: this.wrapperEle,
              },
            })
          );
        }

        disconnectedCallback() {
          if (this.isMoving) return;
          if (this.wrapperEle) {
            this.wrapperEle.removeEventListener('click', this.handleWrapperClick.bind(this));
          }
          if (this.closeBtnEle) {
            this.closeBtnEle.removeEventListener('click', this.handleCloseBtnClick.bind(this));
          }
          this.placeholder?.remove();
          GlobalModal.instances.delete(this);
        }
      }
    );
  }
});

$(function () {
  if (window.ModalController) return;

  // 弹窗控制器
  class ModalController {
    #modals = new Map();
    constructor() {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          const openModals = Array.from(document.querySelectorAll('global-modal[data-is-open]'))
            .filter((modal) => modal.isOpen)
            .sort((a, b) => b.level - a.level);
          openModals[0]?.close();
        }
      });
    }

    register(modalId, { onOpen, onClose } = {}) {
      const modal = document.querySelector(`global-modal[data-modal-id="${modalId}"]`);
      if (!modal) return;

      if (onOpen) modal.addEventListener('modal-opened', (event) => onOpen(event.detail.wrapperEle));
      if (onClose) modal.addEventListener('modal-closed', (event) => onClose(event.detail.wrapperEle));

      this.#modals.set(modalId, modal);
      return modal;
    }

    getModal(modalId) {
      return this.#modals.get(modalId);
    }

    open(modalId) {
      this.#modals.get(modalId)?.open();
    }

    // 关闭指定弹窗
    close(modalId) {
      this.#modals.get(modalId)?.close();
    }
  }
  window.ModalController = ModalController;
});
